/* eslint-disable max-len */
const productConfig = {
  type: 'product',
  steps: [
    {
      step: 'description',
      cardTitle: 'Tell us about your product',
      fields: {
        name: {
          title: 'What kind product are you selling?',
          subTitle: 'Use the generic name using articles a/an or in plural - no brand name. \n\n *By default your first letter will be forced in lower case - this is to ensure that the survey looks good*.',
          placeholder: 'For example: “running shoes”, “a vegan leather bag” or “a laundry machine”',
          tooltip: `<div>
                        <p>Make sure your product type is accurately described.</p>
                        <ul style="padding-left: 15px">
                          <li>Do <b>not</b> use any brand terms in the 'product type' input field.</li>
                          <li>Try and be a bit more descriptive, don't say 'shoes' but rather 'running shoes'</li>
                          <li>Make sure you use: <b>plural /a /an</b></li>
                        </ul>
                    </div>`,
        },
        description: {
          title: 'Describe what’s unique with your product',
          subTitle: 'Write as much as you know about your product. What it is, what makes it special, who it’s for, and how it’s used. No brand name.',
          placeholder: 'For example: “A vegan leather bag made in Italy using top-stitched eco-materials and a gold-tone clasp. Designed for fashion-conscious shoppers who want cruelty-free luxury. Its structured shape works for both everyday wear and special occasions.”',
          tooltip: `<div>
                      <p>The more detail you include here, the better the AI can generate a relevant introduction for your study.</p>
                      <p>Focus on facts, not sales language. Avoid brand names and words like <i>my</i> or <i>our</i> — use <i>this</i> or <i>these</i> instead.</p>
                    </div>`,
        },
        quantity: {
          title: '(Optional) What is the quantity of your product?',
          tooltip: "This is not relevant for all products. But if you want your potential customers to know the exact quantity of your product this will give better results. For example, 3 ounces of perfume would have a different price than 4.2 ounces, so it's sometimes important your customers know how much they are asked to pay. (But if you sell sneakers this is of course not applicable to you and you can ignore this question and move on)"
        },
        price: {
          title: 'What is the intended price of the product?',
          paymentModels: [
            { label: 'Per unit sold', value: 'per_unit_sold' },
            { label: 'Per Month', value: 'per_month' },
            { label: 'Per Year', value: 'per_year' },
          ],
          tooltip: "Here you should fill out the current pricing model, if you don't have a current pricing model you fill out your intended pricing model.",
        },
        // usageFrequency: {
        //   title: 'Find out how often people would use your service or product:',
        //   tooltip: 'With this field activated you will get insights on how people often your prospective customers use you product or service. This question is optional as it isn’t suitable for everyone. We suggest you toggle it on and review how it looks in the preview section. If it doesn\'t look right you can always edit it off from there.',
        // },
      },
    },
    {
      step: 'targetGroup',
      cardTitle: 'Tell us about your intended customers',
      title: 'Tell us more about your targeted customer',
      subTitle: 'Who are you selling to, and who you want to be selling to',
      tooltip: {
        gender: '<div><p>In this section we want to see who your intended customers are. Select the age and gender of who you want to answer what they are willing to pay for your product.</p><p>If you select from 25+ this means that will not get any responses from people below the age of 25.</p></div>',
        regions: '<div><p>In this section we want to know your targeted country and or regions. The broader you are the more options you will have on filtering once you get the results. This means that you can get great insights based on a geographical and regional level, which can allow you to focus sales efforts there.</p><p>However, if you are limited to a geographical region and cannot sell to certain parts of a country you should limit to the areas which you can service.</p></div>',
      },
    },
  ],
};

export const quickQuestionProjectFormConfig = {
  product: productConfig,
  service: productConfig,
};

export type QuickQuestionProjectFormConfigType = typeof quickQuestionProjectFormConfig;
export type QuickQuestionProductConfigType = typeof quickQuestionProjectFormConfig['product'];
export type QuickQuestionStepConfigType = QuickQuestionProductConfigType['steps'][number];
